/**
 * Candidate screen for the production dashboard. Not imported by the live build.
 *
 * Wire later, only after approval:
 * - screens/index.js owner block: Route path={`${match.url}/brand-discounts`} component={BrandDiscounts}
 * - same owner menu, next to supplier-prices: Link to="/dashboard/brand-discounts" title مدیریت تخفیف برندها
 * - auth/permissions.js routes below, permission catalog.products.excel (owner only)
 *   GET/PUT/DELETE /brand-discounts and /brand-discounts/:id
 *   POST /brand-discounts/:id/rollback
 *   GET /brand-discounts/audit
 */
import Axios from "axios";
import React, { useEffect, useState } from "react";
import { storage } from "../../utils";
import styles from "./BrandDiscounts.module.css";

async function token() {
  const value = await storage.load("token");
  if (!value) throw new Error("نشست پیدا نشد. دوباره وارد شوید.");
  return value;
}

function money(value) {
  if (value == null || value === "") return "—";
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("fa-IR");
}

const BrandDiscounts = () => {
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [list, setList] = useState(null);
  const [current, setCurrent] = useState(null);
  const [percent, setPercent] = useState("0");
  const [enabled, setEnabled] = useState(true);
  const [audit, setAudit] = useState([]);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const load = async (nextPage = page, nextQuery = query) => {
    const auth = await token();
    const res = await Axios.get("/brand-discounts", {
      headers: { "x-auth": auth },
      params: { q: nextQuery, page: nextPage, pageSize: 20 },
    });
    setList(res.data);
  };

  const loadAudit = async () => {
    const auth = await token();
    const res = await Axios.get("/brand-discounts/audit", { headers: { "x-auth": auth } });
    setAudit(res.data.data || []);
  };

  useEffect(() => {
    load(1, "").catch((error) => setErr(error.message || "خطا"));
    loadAudit().catch(() => setAudit([]));
  }, []);

  const openBrand = async (id) => {
    const auth = await token();
    const res = await Axios.get(`/brand-discounts/${encodeURIComponent(id)}`, { headers: { "x-auth": auth } });
    setCurrent(res.data);
    setPercent(String(res.data.rule ? res.data.rule.percent : 0));
    setEnabled(res.data.rule ? res.data.rule.enabled : true);
    setErr("");
    setMsg("");
  };

  const save = async (nextEnabled) => {
    if (!current) return;
    if (!window.confirm("قانون تخفیف این برند ذخیره شود؟ قیمت و درصد خود کالا عوض نمی‌شود.")) return;
    const auth = await token();
    setErr("");
    try {
      await Axios.put(`/brand-discounts/${encodeURIComponent(current.id)}`, {
        percent: Number(percent),
        enabled: nextEnabled,
        version: current.rule ? current.rule.version : 0,
      }, { headers: { "x-auth": auth } });
      setMsg("ذخیره شد.");
      await openBrand(current.id);
      await load();
      await loadAudit();
    } catch (error) {
      setMsg("");
      setErr((error.response && error.response.data && error.response.data.message) || "ذخیره انجام نشد.");
    }
  };

  const remove = async () => {
    if (!current || !current.rule) return;
    if (!window.confirm("قانون این برند حذف شود؟ پس از حذف، تخفیف مؤثر همه کالاهای این برند صفر می‌شود و درصد اختصاصی کالاها برنمی‌گردد. درصد ذخیره‌شده کالا در پایگاه می‌ماند.")) return;
    const auth = await token();
    try {
      await Axios.delete(`/brand-discounts/${encodeURIComponent(current.id)}`, {
        headers: { "x-auth": auth },
        data: { version: current.rule.version },
      });
      setMsg("قانون حذف شد.");
      await openBrand(current.id);
      await load();
      await loadAudit();
    } catch (error) {
      setErr((error.response && error.response.data && error.response.data.message) || "حذف انجام نشد.");
    }
  };

  const pages = list ? Math.max(1, Math.ceil(list.total / list.pageSize)) : 1;

  return (
    <div className={styles.root}>
      <div className={styles.head}>
        <h1>مدیریت تخفیف برندها</h1>
        <p>قانون فعال، درصد مؤثر همه کالاهای همان برند است. قانون غیرفعال صفر درصد است و درصد خود کالا برنمی‌گردد.</p>
      </div>
      <div className={styles.card}>
        <div className={styles.row}>
          <input value={query} placeholder="جستجوی نام فارسی یا انگلیسی" onChange={(event) => setQuery(event.target.value)} />
          <button type="button" onClick={() => { setPage(1); load(1, query).catch((error) => setErr(error.message)); }}>جستجو</button>
        </div>
        <table className={styles.table}>
          <thead>
            <tr><th>برند</th><th>کالا</th><th>درصد برند</th><th>وضعیت</th></tr>
          </thead>
          <tbody>
            {(list && list.data ? list.data : []).map((brand) => (
              <tr key={brand.id}>
                <td><button type="button" className={styles.ghost} onClick={() => openBrand(brand.id)}>{brand.title}</button></td>
                <td>{money(brand.count)}</td>
                <td>{brand.rule ? money(brand.rule.percent) : "—"}</td>
                <td>{brand.rule ? (brand.rule.enabled ? "فعال" : "غیرفعال") : "ندارد"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className={styles.row}>
          <button type="button" className={styles.ghost} disabled={page <= 1} onClick={() => { const next = page - 1; setPage(next); load(next).catch(() => {}); }}>قبلی</button>
          <span>{money(page)} از {money(pages)}</span>
          <button type="button" className={styles.ghost} disabled={page >= pages} onClick={() => { const next = page + 1; setPage(next); load(next).catch(() => {}); }}>بعدی</button>
        </div>
      </div>
      {current ? (
        <div className={styles.card}>
          <h2>{current.title}</h2>
          <p>
            کالا {money(current.count)} · مشمول برند {money(current.preview.affected)} · درصد اختصاصی {money(current.preview.productPriority)} · بدون قیمت {money(current.preview.missingPrice)}
          </p>
          <label>درصد <input type="number" min="0" max="100" step="0.01" value={percent} onChange={(event) => setPercent(event.target.value)} /></label>
          <label><input type="checkbox" checked={enabled} onChange={(event) => setEnabled(event.target.checked)} /> فعال</label>
          <div className={styles.row}>
            <button type="button" onClick={() => save(enabled)}>ذخیره با تأیید</button>
            <button type="button" className={styles.ghost} onClick={() => save(false)}>غیرفعال</button>
            <button type="button" className={styles.warn} onClick={remove}>حذف قانون</button>
          </div>
          <table className={styles.table}>
            <thead><tr><th>نمونه</th><th>قیمت اصلی</th><th>درصد مؤثر</th><th>بعد از تخفیف</th></tr></thead>
            <tbody>
              {current.preview.examples.concat(current.preview.priorityExamples).map((row) => (
                <tr key={row.id + row.effect}>
                  <td>{row.title}</td>
                  <td>{money(row.price)}</td>
                  <td>{money(row.effectivePercent)}</td>
                  <td>{row.orderUnitNet == null ? "—" : money(row.orderUnitNet)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {msg ? <p className={styles.ok}>{msg}</p> : null}
          {err ? <p className={styles.err}>{err}</p> : null}
        </div>
      ) : null}
      <div className={styles.card}>
        <h2>سابقه</h2>
        {audit.map((row) => (
          <p key={row._id}>{row.action} · {row.adminRole} · {row.brandId}</p>
        ))}
      </div>
    </div>
  );
};

export default BrandDiscounts;
